// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hoverable {
  transition: background-color 0.3s ease;
}

.hoverable:hover {
  background-color: #f0f0f0;
  color: #000;
}

/* Multi-Select Used for Country Selection*/

.multi-select .select__control {
  background-color: var(--bs-body-bg);
  border: 1px solid var(--border-color-light); 
  color: #fff !important;
}

/* For focused state */
.multi-select .select__control--is-focused {
  border-color: #555 !important;
  box-shadow: 0 0 0 1px #555 !important;
}

/* Dropdown menu */
.multi-select .select__menu {
  background-color: #333 !important;
  color: #fff !important;
}

/* Dropdown options */
.multi-select .select__option {
  padding: 10px !important;
  background-color: transparent !important;
  color: #ddd !important;
}

.multi-select .select__option--is-focused {
  background-color: #444 !important;
  color: #fff !important;
}

.multi-select .select__option--is-selected {
  background-color: #555 !important;
  color: #fff !important;
}

/* Multi-value (selected tags) */
.multi-select .select__multi-value {
  background-color: #444 !important;
  color: #fff !important;
}

.multi-select .select__multi-value__label {
  color: #fff !important;
}

.multi-select .select__multi-value__remove {
  color: #fff !important;
}

.multi-select .select__multi-value__remove:hover {
  background-color: #666 !important;
  color: #fff !important;
}

/* Placeholder styling */
.multi-select .select__placeholder {
  color: #999 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Shipping.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,2CAA2C;;AAE3C;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA,kBAAkB;AAClB;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,wBAAwB;EACxB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;AACxB","sourcesContent":[".hoverable {\n  transition: background-color 0.3s ease;\n}\n\n.hoverable:hover {\n  background-color: #f0f0f0;\n  color: #000;\n}\n\n/* Multi-Select Used for Country Selection*/\n\n.multi-select .select__control {\n  background-color: var(--bs-body-bg);\n  border: 1px solid var(--border-color-light); \n  color: #fff !important;\n}\n\n/* For focused state */\n.multi-select .select__control--is-focused {\n  border-color: #555 !important;\n  box-shadow: 0 0 0 1px #555 !important;\n}\n\n/* Dropdown menu */\n.multi-select .select__menu {\n  background-color: #333 !important;\n  color: #fff !important;\n}\n\n/* Dropdown options */\n.multi-select .select__option {\n  padding: 10px !important;\n  background-color: transparent !important;\n  color: #ddd !important;\n}\n\n.multi-select .select__option--is-focused {\n  background-color: #444 !important;\n  color: #fff !important;\n}\n\n.multi-select .select__option--is-selected {\n  background-color: #555 !important;\n  color: #fff !important;\n}\n\n/* Multi-value (selected tags) */\n.multi-select .select__multi-value {\n  background-color: #444 !important;\n  color: #fff !important;\n}\n\n.multi-select .select__multi-value__label {\n  color: #fff !important;\n}\n\n.multi-select .select__multi-value__remove {\n  color: #fff !important;\n}\n\n.multi-select .select__multi-value__remove:hover {\n  background-color: #666 !important;\n  color: #fff !important;\n}\n\n/* Placeholder styling */\n.multi-select .select__placeholder {\n  color: #999 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
